module.exports = __webpack_public_path__ + "img/TestPanelDMP.1c6ebff4.svg";